import { getEvents } from '../../../browser/services/events';
import { TThunkAction } from '../../types/redux';
import { updateState } from '../headerState';
import { modalClose } from './modalClose';

export const userAuthenticated = (): TThunkAction => {
  return (dispatch, getState) => {
    const {
      authentication: { autoRefresh },
    } = getState();

    getEvents().userAuthenticated();

    if (autoRefresh) {
      window.location.reload();
    } else {
      dispatch(modalClose(true));
      dispatch(updateState());
    }
  };
};
